/**
 * POST a portal JWT and OAuth params to the MCP bridge endpoint.
 * Returns the redirect_url the SPA should navigate to next.
 *
 * @param {{ mcpBaseUrl: string, portalJwt: string, params: object }} options
 * @returns {Promise<string>}
 */
export const postAuthorizeBridge = async ({
  mcpBaseUrl,
  portalJwt,
  params,
}) => {
  const response = await fetch(`${mcpBaseUrl}/authorize/bridge`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${portalJwt}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });

  if (!response.ok) {
    const error = new Error(`Bridge failed: ${response.status}`);
    error.status = response.status;
    throw error;
  }

  const body = await response.json();
  return body.redirect_url;
};
